module.exports = {
  GraficaD3: {
    PluginName: "Grafik",
    style: "Stil",
    margin: "Margin",
    left: "Sol",
    right: "Sağ",
    top: "Üst",
    bottom: "Alt",
    padding: "Alan",
    border_width: "Çerçeve Genişliği",
    border_style: "Çerçeve Stili",
    border_color: "Çerçeve Rengi",
    border_radius: "Çerçeve Radyanı",
    opacity: "Opaklık",
    name: "İsim",
    axis: "Eksen",
    axes_v: "Dikey Eksen",
    axes_h: "Yatay Eksen",
    ring: "Halka",
    rings: "Halkalar",
    title: "Başlık",
    edit: "Düzenle",
    color: "Renk",
    grid: "Grid",
    Graph: "Grafik",
    number_graphs: "Grafik Sayısı",
    see_grid: "Gridi Gör",
    x_grid: "X ekseni",
    y_grid: "Y ekseni",
    line_color: "Çizgi rengi",
    file: "Dosya seç",
    or: "Veya",
    x_axis: "X Ekseni",
    y_axis: "Y Ekseni",
    chart_type: "Grafik Türü",
    order_by: "Sırala",
    data_rows: "Satır Sayısı",
    data_cols: "Sütun Sayısı",
    key: "Anahtar",
    value: "Değer",
    vertical: "Dikey",
    horizontal: "Yatay",
    alert_msg: "Tablodaki bütün alanları doldurun",
    confirm: "Onayla",
    fill_in: "Veya bir tablo doldurun",
    show: "Göster",
    preview: "Ön izleme",
    Row: "Satır",
    Column: "Sütun",
    row_name: "Grafik Adı",
    types: {
      line: "Çizgi",
      area: "Alan",
      bar: "Çubuk",
      pie: "Pie",
    },
    header: {
      options: "Grafik Seçenekleri",
      origin: "Veri Kaynağı",
      preview: "Ön izleme",
    },
    example: {
      example_name_surname_txt: "İsim Soyisim",
      example_age_txt: "Yaş",
      example_country_txt: "Ülke",
      examplename1: "Gamze Özverdi",
      examplename2: "Kemal Yılmaz",
      exampleage1: "16",
      exampleage2: "23",
    },
  },
};
